// extracted by mini-css-extract-plugin
export default {"approve":"approve-module--approve--epaMg","approveCont":"approve-module--approveCont--f4HPC","approveIcon":"approve-module--approveIcon--M+hAV","buts":"approve-module--buts--ruzfk"};